<template>
  <div class="body">
    <div class="form bg-white p20 mb20">
      <el-form ref="form" :model="listParams"   label-width="80px" @submit.native.prevent>
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="考试名称" prop="examName">
              <el-input v-model="listParams.examName" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="pr20">
            <el-form-item label="考试类型" prop="examType">
              <el-select v-model="listParams.examType" clearable placeholder="请选择">
                <el-option :label="item.text" :value="item.code" v-for="(item,index) in examTypeList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" class="pr20">
            <el-form-item label="考试时间" prop="date">
              <el-date-picker
                v-model="listParams.date"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="searchBut">
          <el-form-item>
            <el-button
              class="mb10"
              type="primary"
              @click="$router.push('/examination/issueExam')"
            >发布考试
            </el-button
            >
            <el-button type="primary" @click="search"
            >搜索
            </el-button
            >
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="bg-white p20 pb50">
      <el-table class="mb20" :data="tableData" style="width: 100%" v-loading="tableLoading"
                element-loading-text="拼命加载中">
        <el-table-column type="index" width="80" label="序号"></el-table-column>
        <el-table-column prop="examName" label="考试名称"></el-table-column>
        <el-table-column prop="examLocation" label="考试地点"></el-table-column>
        <el-table-column prop="startTimeString" label="考试开始时间"></el-table-column>
        <el-table-column prop="endTimeString" label="考试结束时间"></el-table-column>
        <el-table-column prop="examTypeString" label="考试类型"></el-table-column>
        <el-table-column prop="peopleNumber" label="考试人数"></el-table-column>
        <!-- <el-table-column prop="examStatus" label="状态"></el-table-column> -->
        <el-table-column
          prop="updateName"
          label="考试计划发布人"
        ></el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="
                $router.push(
                  `/examination/issueExam?id=${scope.row.id}&type=check`
                )
              "
            >查看
            </el-button
            >
            <!-- <el-button size="mini" type="primary">编辑</el-button>
            <el-button size="mini" type="warning">监考人签到</el-button>
            <el-button size="mini" type="danger">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;"
        background
        layout="total ,prev, pager, next"
        :total="total"
        :current-page="listParams.page"
        :page-size="listParams.pageSize"
        @current-change="pageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import exam from "../../api/new/exam.js";

export default {
  data() {
    return {
      questionTypeList: [], // 题型列表
      tableData: [],
      examTypeList: [],
      listParams: {
        page: 1,
        pageSize: 10,
        examName: undefined,
        date: undefined,
        examType: undefined,
        tableLoading: false,
      },
      total: 0,
      tableLoading: false
    };
  },
  mounted() {
    let issueExam = localStorage.getItem("issueExam");
    this.examTypeList = JSON.parse(localStorage.getItem("exam_type"));
    if (issueExam) {
      setTimeout(() => {
        this.examStatisticsList();
        localStorage.removeItem("issueExam");
      }, 2000);
    } else {
      this.examStatisticsList();
    }
  },
  methods: {
    search() {
      this.listParams.page = 1;
      this.examStatisticsList();
    },
    //统计列表
    examStatisticsList() {
      let that = this;
      let listParams = {
        ...this.listParams,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      if (listParams.date && listParams.date.length) {
        listParams.startTime = listParams.date[0];
        listParams.startTimeEnd = listParams.date[1];
      } else {
        listParams.startTime = undefined;
        listParams.startTimeEnd = undefined;
      }
      delete listParams.date;

      this.tableLoading = true;
      exam.examStatisticsList(listParams).then(res => {
        if (res && res.data.records) {
          // res.data.records.forEach(v=>{
          //   this.examTypeList.forEach(v2=>{
          //     if(v.examType == v2.code){
          //       v.examType
          //     }
          //   })
          // })
          that.tableData = res.data.records;
          that.total = res.data.total;
          that.tableLoading = false;
        }
      });
    },
    /**
     * 重置表单
     */
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
        this.search();
      });
    },
    pageChange(e) {
      this.listParams.page = e;
      this.examStatisticsList();
    },

  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/examination/examManagement.vue